import { createConfig, type Config, http } from 'wagmi'
import { base, baseSepolia } from 'wagmi/chains'
import { farcasterMiniApp } from '@farcaster/miniapp-wagmi-connector'
import { METADATA } from '../utils/baseAppUtils'

let cachedConfig: Config | null = null

// AGC: FIX 2025-12-01 - Use same RPC URLs as desktop config to ensure consistent balance reads
const baseSepoliaRpc =
  import.meta.env.VITE_BASE_SEPOLIA_RPC_URL ||
  import.meta.env.VITE_BASE_RPC_URL ||
  'https://sepolia.base.org'

const baseMainnetRpc =
  import.meta.env.VITE_BASE_MAINNET_RPC_URL ||
  'https://mainnet.base.org'

const createFarcasterConfig = (): Config => {
  return createConfig({
    chains: [baseSepolia, base],
    connectors: [
      farcasterMiniApp({
        appName: METADATA.name,
        appIconUrl: METADATA.icon,
        rpcUrl: baseSepoliaRpc,
        metadata: {
          name: METADATA.name,
          description: METADATA.description,
          url: METADATA.url,
          iconUrl: METADATA.icon,
        },
      }),
    ],
    transports: {
      [base.id]: http(baseMainnetRpc),
      [baseSepolia.id]: http(baseSepoliaRpc),
    },
  })
}

export const getFarcasterConfig = (): Config => {
  if (!cachedConfig) {
    cachedConfig = createFarcasterConfig()
  }
  return cachedConfig
}
